import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
import VideoSection from '../components/VideoSection';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import VideoGallery from '../components/VideoGallery';
import CulturalHighlight from '../components/CulturalHighlight';
import ChristmasHighlight from '../components/ChristmasHighlight';
import Music from '../components/Music';
import Packages from '../components/Packages';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';

const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 300);
    }
  }, [location]);
  return (
  <main>
    <Hero />
    <About />
    <ChristmasHighlight />
    <VideoSection />
    <Services />
    <Gallery />
    <VideoGallery />
    <CulturalHighlight />
    <Music />
    <Packages />
    <Testimonials />
    <FAQ />
    <Contact />
  </main>
  );
};

export default HomePage;
